import styled from 'styled-components';

export const CompetitionLastRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  margin: 0.7em 0.3em 1.2em 1.2em;
  font-size: 1.2em;
  align-self: flex-end;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    align-self: center;
    justify-content: center;
    margin: 1em 0.3em 1.2em;
  };
  display: ${props => ((props.competitionId === '88') || (props.competitionId === '34') || (props.competitionId === '1166') ? 'none' : '')};
`;

export const CompetitionCalendar = styled.div`
  margin-left: 0.5em;
  //cursor: pointer;
  display: ${props => ((props.competitionId === '88') || (props.competitionId === '34') || (props.competitionId === '1166') ? 'none' : '')};
`;

export const CompetitionStandings = styled.div`
  margin-left: 0.5em;
  cursor: pointer;
  display: ${props => ((props.competitionId === '88') || (props.competitionId === '34') || (props.competitionId === '1166') ? 'none' : '')};
`;
